// Purpose: Connects a component with redux and react-router

import { connect } from 'react-redux';

export default (unconnectedComponent, ...mapFunctions) => {
  return connect(...mapFunctions)(unconnectedComponent);
};
